module.exports = __webpack_public_path__ + "img/facebook_wh.e63ff513.svg";